import type { Milestone } from '../types/executive'

export const milestones: Milestone[] = [
  {
    period: '2026 — Present',
    role: 'Founder & Principal',
    organization: 'Conroy Advisory Group, LLC',
    summary:
      'Advises owners, boards, and contractors on capital strategy, governance, and alternative delivery for complex institutional programs.',
    highlights: [
      'Strategic capital & board advisory',
      'JV governance and controls',
      'Enterprise risk structuring',
    ],
  },
  {
    period: '2014 — 2026',
    role: 'Vice President, Western Region & Board of Directors Member',
    organization: 'Austin Commercial',
    summary:
      'Held full regional P&L responsibility across the Western U.S., leading the business unit from deficit to sustained profitability while delivering a $585M aviation portfolio.',
    highlights: [
      '$585M aviation portfolio, zero critical claims',
      '$460M LAX APM terminal cores (Design-Build)',
      'GLAACC 2025 Contractor of the Year',
    ],
  },
  {
    period: '2013 — 2014',
    role: 'Director of Southern California',
    organization: 'The PENTA Building Group',
    summary:
      'Established Southern California presence and led pursuit and delivery of campus and healthcare work across CA and NV.',
    highlights: [
      'USC campus expansion program',
      '$250M Henderson, NV healthcare (Lean IPD)',
    ],
  },
  {
    period: '2010 — 2013',
    role: 'Vice President, Healthcare',
    organization: 'Snyder Langston',
    summary:
      'Recruited to build the firm’s healthcare market from the ground up, growing negotiated backlog from $0 to $120M.',
    highlights: [
      '$120M negotiated healthcare backlog built',
      '$80M Providence Breeze Cancer Center',
      '$37M Los Alamitos Medical Plaza in 14 months',
    ],
  },
  {
    period: '2003 — 2010',
    role: 'Project Executive',
    organization: 'Rudolph and Sletten',
    summary:
      'Led delivery of two of Southern California’s largest institutional programs of the period under CMAR and competitive public-sector pursuit.',
    highlights: [
      '$410M Kaiser Permanente LAMC rebuild',
      '$225M San Bernardino Justice Center',
    ],
  },
]
